import React, { useState } from 'react'

const faqContent = [
  {
    question: `How do i claim my rewards?`,
    answer: (
      <p>
        Once your staking period has ended you will be able to claim any rewards
        earned by simply pressing the 'Claim Rewards' button.
      </p>
    ),
  },
  {
    question: `Where are my rewards paid?`,
    answer: (
      <p>
        Once your staking period has ended you will be able to claim any rewards
        earned.
        <br />
        Rewards are paid in BUSD to the connected wallet when staking XOPAD. Add
        the BUSD contract to your wallet to see your BUSD balance.
      </p>
    ),
  },
  {
    question: 'Is there a minimum staking period to receive my BUSD rewards?',
    answer: (
      <p>
        The minimum amount of time you are required to stake before receiving
        BUSD rewards is 30 days, this will be a rolling 30-day cycle.
      </p>
    ),
  },
  {
    question: `Can I stake more once i've already staked some XOPAD?`,
    answer: (
      <p>
        Yes, but this will reset the staking timer back to 30 days. This is to
        keep it fair to all stakers
        <br /> <br />
        If you don't want to reset your staking timer, use a separate wallet to
        stake the coins. But you will still have to wait for 30 days for the new
        wallet!
      </p>
    ),
  },
  {
    question: 'Is there a minimum lock period for my XOPAD?',
    answer: <p>The minimum lock period for XOPAD is rolling 30 days</p>,
  },
  // {
  //   question:
  //     'What happens to my BUSD if I un-stake my XOPAD before a 30 day cycle is complete?',
  //   answer: (
  //     <p>
  //       If you decide to un-stake your XOPAD before completing a 30-day cycle,
  //       the BUSD rewards calculated so far will be forfeited and used to buy and
  //       burn XOPAD tokens, this will reduce the total XOPAD token supply and
  //       increase the liquidity pool which will create a much stronger ecosystem
  //       which will benefit all holders.
  //     </p>
  //   ),
  // },
  {
    question: 'Is there any limit to staking?',
    answer: <p>No, there is no limit to the amount of XOPAD you can stake.</p>,
  },
  {
    question: 'How are rewards calculated?',
    answer: (
      <p>
        BUSD rewards are calculated based on the daily trading volume of the
        XOPAD token, rewards are paid up to 100% APR*
        <br /> <br />
        Please note this is not a fixed income scheme.
      </p>
    ),
  },
  {
    question: 'What if the APR changes between claiming rewards?',
    answer: (
      <p>
        When the APR changes, your current earned rewards are 'locked' in. So
        you can utilise high APR rates by keeping your tokens staked without
        having to do anything.
        <br /> <br />
        If the APR rate then decreases, you still got the correct rate for the
        high APR period.
      </p>
    ),
  },
  {
    question: 'Where do the BUSD rewards come from?',
    answer: (
      <p>
        Rewards come from the buy and sell taxes, there is an 11% buy and sell
        tax, and 3% of this is a rewards fee which is converted to BUSD and
        stored in the rewards wallet.
      </p>
    ),
  },
  {
    question:
      'Can I reinvest my BUSD into XOPAD to compound and receive a higher return?',
    answer: (
      <p>
        Yes, you can claim your BUSD at the end of each 30 days staking cycle
        and purchase more XOPAD which you can then stake to increase your
        returns, this is called compounding and will result In a higher return
        over the course of a year, you can use a compound interest calculator to
        get an idea on the returns based on different APR rates.
        <br /> <br />
        There will be a buy XOPAD button on the staking interface to make this
        process as simple as possible.
      </p>
    ),
  },
  {
    question: 'I am having issues connecting with trust wallet?',
    answer: (
      <p>
        Trust wallet automatically connects in Ethereum, when clicking connect
        wallet, you will select the trust wallet option, you will then be
        prompted to connect, before you do this, please click the Ethereum
        symbol in the middle of the page and change it to smart chain (BNB) and
        click connect. You will now be connected via trust wallet and you can
        now go back to the XOPAD staking page and choose your token amount to
        stake.
      </p>
    ),
  },
  {
    question: `I'm have an issue not listed, is there support?`,
    answer: (
      <p>
        Yes, please contact support by joining our telegram group. Either a mod
        or the community will be able to help.
      </p>
    ),
  },
]
const FAQ = () => {
  const [active, setActive] = useState<number>(0)

  const handleOnClick = (index: number) => {
    if (active === index + 1) {
      setActive(0)
      return
    }
    setActive(index + 1)
  }
  return (
    <div className="mt-20">
      <div className="relative flex justify-center">
        <span className="font-heading px-3 font-medium text-3xl text-white">
          FAQ
        </span>
      </div>

      <div id="accordion-open" data-accordion="collapse" className="mt-5">
        {faqContent.map((item, index) =>
          index === 0 ? (
            <div>
              <h2 id="accordion-open-heading-0">
                <button
                  type="button"
                  className={`flex justify-between items-center p-5 w-full font-medium rounded-t-xl text-left text-gray-500 border ${
                    index !== faqContent.length - 1 && 'border-b-0'
                  }  border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-ebony-clay-700 dark:focus:bg-ebony-clay-700`}
                  data-accordion-target="#accordion-open-body-0"
                  aria-expanded="true"
                  aria-controls="accordion-open-body-0"
                  onClick={() => {
                    handleOnClick(index)
                  }}
                >
                  <span className="flex items-center">
                    <svg
                      className="mr-2 w-5 h-5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      ></path>
                    </svg>{' '}
                    {item.question}
                  </span>
                  <svg
                    data-accordion-icon=""
                    className="w-6 h-6 rotate-180 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </h2>
              <div
                id="accordion-open-body-1"
                className={`${active !== index + 1 ? 'hidden' : ''}`}
                aria-labelledby="accordion-open-heading-1"
              >
                <div
                  className={`p-5 border border-b-0 border-gray-200 dark:border-gray-700`}
                >
                  <p className="mb-2 text-gray-500 dark:text-gray-400">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <h2 id={`accordion-open-heading-${index}`}>
                <button
                  type="button"
                  className={`flex justify-between items-center p-5 w-full font-medium text-left text-gray-500 border ${
                    index !== faqContent.length - 1
                      ? 'border-b-0'
                      : 'rounded-b-xl'
                  }  border-gray-200  dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-ebony-clay-700 dark:focus:bg-ebony-clay-700`}
                  aria-expanded="false"
                  aria-controls={`accordion-open-body-${index}`}
                  onClick={() => {
                    handleOnClick(index)
                  }}
                >
                  <span className="flex items-center">
                    <svg
                      className="mr-2 w-5 h-5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    {item.question}
                  </span>
                  <svg
                    data-accordion-icon=""
                    className="w-6 h-6 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </h2>
              <div
                id="accordion-open-body-2"
                className={`${active !== index + 1 && 'hidden'}`}
                aria-labelledby="accordion-open-heading-2"
              >
                <div
                  className={`p-5 border border-t-0 border-gray-200 dark:border-gray-700 ${
                    index === faqContent.length - 1
                      ? 'border-t-0 '
                      : 'border-b-0'
                  } `}
                >
                  <p className="mb-2 text-gray-500 dark:text-gray-400">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default FAQ
